<template>
<div class="wrapper-card" >
  <carousel ref="feedbackCarousel" :per-page="1" :paginationEnabled="false"  :navigationEnabled="false" :mouseDrag="false"  >
    <slide v-for="(item, index) in content" :key="index">

    <div class="card">
        <div class="cr-box " >
        <div class="custom-icon-carousel" >
                  <button  style="margin-left:-25px !important;" v-if="currentSlide != 0" @click.prevent="prevSlide">
                    <font-awesome-icon  icon="spinner" class="icon-pre " style="cursor: pointer; color:#ADB0B3; " :icon="['fas', 'chevron-left']"  />
                  </button>
                  <button  style="margin-left: 145px!important;" v-if="currentSlide != carouselLength - 1" @click.prevent="nextSlide">
                    <font-awesome-icon  icon="spinner" class="icon-next" style="cursor: pointer; color:#ADB0B3; " :icon="['fas', 'chevron-right']"  />
                  </button>
                </div> 
          <div class="v-responsive v-image ">
            <div class="v-responsive__sizer" style="padding-bottom: 100%;"></div>
            <div>                      
              <div  
                class="v-image__image v-image__image--contain border-bottom"  
                :style="{'background-image': 'url(' + item.image_url +')'}">
              </div>
                  
                <div>
                
                </div>
            </div>          
            <div class="v-responsive__content" ></div>
            <div class="card-title  " >
              <div class="sub-title-1 " >{{item.title}}</div>
            </div>
          </div>
        <div class="title align-self-end  ">
          <div class="sub-title-1 align-self-end  " v-if="item.buttons.length > 0">
            <div class="content border-top  " v-for="(ele, ind) in item.buttons" :key="ind">
              <CustomButton :content="ele" />
            </div>
          </div>
        </div>
      </div>
    </div>
    </slide>
  </carousel>
</div>
</template>
<script>
import CustomButton from "./CustomButton";
import { Carousel, Slide } from "vue-carousel";
export default {
  props: ["message"],
  components: { Carousel, Slide, CustomButton },
  data() {
    return {
      content: [],
      currentSlide: 0
    };  
  },
  computed: {
    carouselLength: function () {
      return this.content.length;
    }
  },
  created() {
    this.content = this.message.message.message.attachment.payload.elements;
  },
 

  methods: {
    nextSlide(){
      this.currentSlide++;
      this.$refs.feedbackCarousel.goToPage(
        this.$refs.feedbackCarousel.getNextPage(),
      )
    },
    prevSlide() {
      this.currentSlide--;
      this.$refs.feedbackCarousel.goToPage(
        this.$refs.feedbackCarousel.getPreviousPage(),
      )
    },

    
  }

};

  
</script>
<style lang="scss" scoped>

.wrapper-card { 

  .card {
    font-family: inherit;
    border-radius: 6% !important;
    width: 180px !important;
    height: 280px;
    margin: 10px;
    padding: 15px;
    .cr-box {
      overflow: hidden;
      border-radius: 0px 10px 0 0 !important;
      background: rgb(255, 255, 255);

      .v-responsive {
        border: 2px black !important;
        position: relative;
        overflow: hidden;
        max-width: 180px;
        display: -webkit-box;  
              
        .v-responsive__sizer {
          -webkit-transition: padding-bottom 0.2s cubic-bezier(0.25, 0.8, 0.5, 1);
          transition: padding-bottom 0.2s cubic-bezier(0.25, 0.8, 0.5, 1);
          -webkit-box-flex: 180px;       
        }

        .img-chat {
          background-position: center center;
          background-repeat: no-repeat;
          background-size: contain;
          z-index: -1;
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        }

        .v-image__image {
          background-position: center center;
          background-size: contain;
          background-repeat: no-repeat;
          z-index: -1;
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 110px;
        }
        
        .v-responsive__content {
          -webkit-box-flex: 1;
          -ms-flex: 1 0 0px;
          flex: 1 0 0px;
          max-width: 100%;
        }
      }

      .v-image {
        z-index: 0;
      }
    }

    .card-title {
      position: absolute;
      bottom: 0;      
      padding: 5px 10px;
      width: 100%;
      margin-bottom: 0px !important;

      .sub-title-1{
        font-size: 15px;
        font-weight: 700;
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }      
    }
    .content{
      width: 100%;
      height: 100%;
      margin-bottom: 0px ;
    }
    .title{
      width: 100%;
      height: 100%;
      margin-top: 5px ;
      
    }
  }
}

.border{
  border-top: 1px  rgba(0, 0, 0, .10)!important;
  display: block!important;
}

.VueCarousel-slide {
    width: 50px !important;   
}

.custom-icon-carousel{
  z-index: 22;
  font-size: 18px;
  position: absolute;
  top: 125px;
  width: 160px;
  display: flex;
  justify-content: space-between;
  
}
.icon-pre {
  font-size: 16px !important; 
}
.icon-next{
  font-size: 16px!important; 
}

.hide-navigation-button {
  display: none;
}
</style>
